<template lang="html">
  <div class="container mx-auto px-4 py-8">
    <h1 class="mb-2 text-3xl font-semibold">
      Новости
    </h1>
    <p v-if="tag" class="mb-8 text-sm text-neutral-500">
      Тег «{{ tag }}» ·
      <NuxtLink to="/news" class="hover:underline">Показать все</NuxtLink>
    </p>
    <div v-else class="mb-8" />

    <ContentFeedList
      :items="collection"
      :pending="pending"
      base-path="/news"
      empty-text="Новостей пока нет."
      :next-href="nextHref"
      @load-more="loadMore"
    />
  </div>
</template>

<script setup lang="ts">
import { ContentType } from '@repo/api/web/models'

import ContentFeedList from '../../components/Listing/ContentFeedList.vue'

definePageMeta({
  name: 'NewsIndex',
})

const { collection, pending, nextHref, tag, loadMore } = await useContentFeed({
  type: ContentType.NEWS,
  listKey: 'news-list',
})

useContentListSeo({ feedTitle: 'Новости', descriptionBase: 'Новости и события', tag })
</script>
